import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import { payloadList, payloadTransactions } from "../../store/agent/transfers";

const getList = (data: payloadList)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.transfersHistory.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getTransactionsById = (data: payloadTransactions)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.transfersHistory.transactions.replace('{transferId}', `${data.transferId}`);

  return fetch(`${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : null}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const transfersService = {
  getList,
  getTransactionsById,
};
